import { render, staticRenderFns } from "./import-product.vue?vue&type=template&id=186c6c3c&"
import script from "./import-product.vue?vue&type=script&lang=ts&"
export * from "./import-product.vue?vue&type=script&lang=ts&"
import style0 from "./import-product.vue?vue&type=style&index=0&id=186c6c3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports